<script setup lang="ts">
import type { ProvisionItemSelect } from "../../common/types.common";
import { defineActions, defineState } from "../common";
import { FormInputCheckbox } from "../input";
import { FormTool } from "../internal";
import { type BaseProps, defaultProps } from "../props";

type ModelType = ProvisionItemSelect[];
interface PropsType extends BaseProps<ModelType> {
    hasValue?: () => boolean;
}

const props = withDefaults(defineProps<PropsType>(), {
    ...defaultProps<ModelType>(),
    value: undefined,
});

const model = defineModel<ModelType | undefined>({
    default: undefined,
});

const state = defineState({
    model: model,
    props: props,
    hasValue: props.hasValue ?? (() => model.value !== undefined),
});

const actions = defineActions(model, props, state);
</script>

<template>
    <div class="flex flex-col gap-2 overflow-x-hidden">
        <div v-if="props.embedMode !== 'inline'" class="flex flex-row items-center px-1 justify-between mr-2">
            <label class="text-gray-600 font-semibold">{{ props.label ?? "Penggunaan Barang" }}</label>
            <FormTool :actions="actions" :param="props" :showUpdate="true" :state="state" />
        </div>

        <div class="w-full overflow-x-auto">
            <table class="rns-items-table">
                <thead>
                    <tr>
                        <th>Nama</th>
                        <th>No. Seri</th>
                        <th>Jumlah</th>
                        <th>Digunakan</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="model?.length === 0">
                        <td colspan="5">Tidak ada barang yang dipesan.</td>
                    </tr>
                    <tr v-for="item in model">
                        <td class="w-2/6">{{ item.name }}</td>
                        <td class="w-2/6">{{ item.code ?? "-" }}</td>
                        <td class="w-1/6">{{ item.quantity }}</td>
                        <td class="w-1/6">
                            <FormInputCheckbox v-model="item.selected" embedMode="inline" :mode="state.nestMode" />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped>
@reference "@/styles/main.css";

.rns-items-table {
    @apply w-full;
}

.rns-items-table th {
    @apply border text-white bg-gray-800 py-2;
}

.rns-items-table td {
    @apply border p-2 text-center;
}
</style>
